<div class="ui-g-12 ui-lg-12 ui-g-nopad associations-steps">
  <p-steps [style]="{'width': '100%'}" [model]="items" [(activeIndex)]="activeTabIndex" [readonly]="false"></p-steps>
</div>
<div class="ui-g-12" style="padding-top: 20px;">
  <app-associations [activeTab]="activeTabIndex"></app-associations>
</div>



// WEBPACK FOOTER //
// ./src/app/views/administration/associations-management/associations-management.component.html